<template>
  <el-form-item
    :label="label"
    class="airport-code"
    :prop="prop"
    :rules="rules"
  >
    <el-autocomplete
      v-model="airportCode"
      :clearable="true"
      :maxlength="4"
      :placeholder="placeholder"
      :disabled="disabled"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="false"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import AutocompleteFilter from '@/mixins/AutocompleteFilter.vue'
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    AutocompleteFilter,
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '空港コード'
    },
    prop: {
      type: String,
      default: 'airport_code'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '半角英字（4文字）'
    }
  },
  computed: {
    airportCode: {
      get () {
        return this.value
      },
      set (airportCode) {
        this.$emit('input', airportCode.toUpperCase())
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
            rules.push(this.validatorRequired(this.label, 'change'))
          }
          if (!this.searchCond) {
            rules.push(this.validatorRegExp(this.label, '^[A-Z]{4}$', 'ICAOコード', 'blur'))
          } else {
            rules.push(this.validatorHalfUCaseAlphabet(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.airport-code {
  ::v-deep .el-form-item__content {
    width: 12em;
  }
}
</style>
